const REQUEST_TOUCH_SCREEN_ORDERS_STATS = "REQUEST_TOUCH_SCREEN_ORDERS_STATS";
const RECEIVE_TOUCH_SCREEN_ORDERS_STATS = "RECEIVE_TOUCH_SCREEN_ORDERS_STATS";

export default {
    REQUEST_TOUCH_SCREEN_ORDERS_STATS, 
    RECEIVE_TOUCH_SCREEN_ORDERS_STATS, 
}